import { connect } from 'react-redux';
import { likeComment, unlikeComment } from '../../redux/actionCreators';
var mapDispatchToProps = {
    onLike: likeComment,
    onUnlike: unlikeComment,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=LikeButton.container.js.map